import { formatDistanceToNow } from "date-fns"
import { useSyncExternalStore } from "react"

interface RelativeTimeProps {
  timestamp: string
  className?: string
}

function subscribeToMinuteTicks(onStoreChange: () => void) {
  const id = window.setInterval(onStoreChange, 60_000)
  return () => window.clearInterval(id)
}

function getMinuteTick() {
  return Math.floor(Date.now() / 60_000)
}

function getServerMinuteTick() {
  return -1
}

export function RelativeTime({ timestamp, className }: RelativeTimeProps) {
  const tick = useSyncExternalStore(subscribeToMinuteTicks, getMinuteTick, getServerMinuteTick)

  if (tick < 0) {
    return (
      <span className={className} title={timestamp}>
        &nbsp;
      </span>
    )
  }

  return (
    <span className={className} title={timestamp}>
      {formatDistanceToNow(new Date(timestamp), { addSuffix: true })}
    </span>
  )
}
